export default __webpack_public_path__ + "static/media/step-three.96f6cd48.png";